import {$http} from '@/utils/https'

import {PASSWORD_UPDATE} from './types/action-types';
import {PASSWORD_UPDATE_LOADING} from './types/mutation-types';

const state = {
    loadingUpdatePassword: false,
};

const getters = {
    loadingUpdatePassword: state => state.loadingUpdatePassword,
};

const actions = {
    [PASSWORD_UPDATE]: async ({commit}, payload) => {
        try {
            commit(PASSWORD_UPDATE_LOADING, true);

            return await $http.post(`${process.env.VUE_APP_ROOT_USER}profile/passwords`, payload);
        } catch (e) {
            throw e;
        } finally {
            commit(PASSWORD_UPDATE_LOADING, false);
        }
    },// eslint-disable-next-line
};

const mutations = {
    [PASSWORD_UPDATE_LOADING](state, status) {
        state.loadingUpdatePassword = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
